/**
 * @fileoverview Уборка снега и реагент на ВПП.
 */

import { Snd } from "../audio/sound";
import type { GameHooks, GameState, Runway } from "../state/types";
import { clamp } from "../util/math";
import { addScore } from "./scoring";

/** Завершить уборку снега на полосе. */
export function finishSnowClear(
  g: GameState,
  hooks: GameHooks,
  r: Runway,
): void {
  void g;
  r.clearSnowT = 0;
  r.clearSnowMax = 0;
  r.snow = Math.min(r.snow, 5);
  if (!(r.tempCloseT > 0)) r.closed = false;
  r.critArmed = true;
  r.snowCool = 0;
  r.clearX = r.x1 + 36;
  hooks.toast(`${r.name} очищена от снега и открыта`, "good");
  addScore(g, hooks, 40, null, "ПОЛОСА ОЧИЩЕНА");
  Snd.ok();
}

/** Тик уборки снега / нанесения реагента. */
export function updateRwyCare(
  g: GameState,
  hooks: GameHooks,
  dt: number,
): void {
  for (const r of g.runways) {
    if (r.clearSnowT > 0) {
      r.clearSnowT -= dt;
      r.closed = true;
      const max = r.clearSnowMax || 1;
      const done = clamp(1 - r.clearSnowT / max, 0, 1);
      r.snow = Math.max(4, (r._snowStart || r.snow) * (1 - done * 0.92));
      r.clearX = clamp(
        r.x1 + 36 + (r.x2 - r.x1 - 72) * done,
        r.x1 + 20,
        r.x2 - 20,
      );
      hooks.plowTrack?.(r.clearX, r.y, r.w * 0.45);
      if (r.clearSnowT <= 0) finishSnowClear(g, hooks, r);
    }
    if (r.clearIceT > 0) {
      r.clearIceT -= dt;
      const max = r.clearIceMax || 1;
      const done = clamp(1 - r.clearIceT / max, 0, 1);
      r.ice = Math.max(0, (r._iceStart || 0) * (1 - done));
      if (r.clearIceT <= 0) {
        r.ice = 0;
        r.clearIceT = 0;
        hooks.toast(`${r.name}: лед снят`, "good");
        addScore(g, hooks, 25, null, "РЕАГЕНТ");
      }
    }
  }
}
